var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container" } }, [
    _c("div", { staticClass: "page" }, [
      _c(
        "div",
        { staticClass: "homenew", attrs: { id: "main-container" } },
        [
          _c(
            "div",
            { staticClass: "flex home-header" },
            [
              _c(
                "div",
                {
                  staticClass: "company-wrapper",
                  on: { click: _vm.choiceCompany }
                },
                [
                  _c("img", {
                    staticClass: "location_icon",
                    attrs: {
                      src: require("../assets/img/home/companyAddress.png"),
                      alt: ""
                    }
                  }),
                  _vm._v(" "),
                  _c("span", { staticClass: "companyName" }, [
                    _vm._v(_vm._s(_vm.subcompanyName))
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "sanjiao_down" })
                ]
              ),
              _vm._v(" "),
              _c("commonSearch", {
                attrs: {
                  searchType: _vm.searchType,
                  type: _vm.styleType,
                  searchMassage: _vm.searchMassage
                },
                on: { goSearch: _vm.goSearch }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.initShow,
                  expression: "initShow"
                }
              ],
              staticClass: "lunbo"
            },
            [
              _c(
                "van-swipe",
                { staticClass: "vanSwipe", attrs: { autoplay: 3000 } },
                _vm._l(_vm.titleIndex, function(image, index) {
                  return _c("van-swipe-item", { key: index }, [
                    _c("img", {
                      staticClass: "needsclick",
                      staticStyle: { width: "100%" },
                      attrs: { src: image.commont },
                      on: {
                        click: function($event) {
                          _vm.goactdetail(image)
                        }
                      }
                    })
                  ])
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "home-menu-zone" },
            [
              _c("menu-panel", {
                attrs: { menus: _vm.menus },
                on: { itemClicked: _vm.goactdetail }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { class: { newSwiper: true, bcf: _vm.newSwiper } },
            [
              _c(
                "van-row",
                { attrs: { gutter: "10" } },
                _vm._l(_vm.roundIndex, function(image, index) {
                  return _c(
                    "van-col",
                    {
                      key: index,
                      staticClass: "commonCol",
                      attrs: { span: "12" }
                    },
                    [
                      _c("img", {
                        attrs: { src: image.commont, alt: "" },
                        on: {
                          click: function($event) {
                            _vm.goactdetail(image)
                          }
                        }
                      })
                    ]
                  )
                }),
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm._l(_vm.tagIndex, function(item, index) {
            return _c("div", { key: item.id, staticClass: "recommendNew" }, [
              item.prodcutList.length == 2
                ? _c("div", { staticClass: "recommendContent" }, [
                    _c("div", { staticClass: "recommendTop" }, [
                      _c("img", {
                        attrs: { src: item.tagImage, alt: "" },
                        on: {
                          click: function($event) {
                            _vm.tagFun(item.id, index)
                          }
                        }
                      })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "recommendBottom" }, [
                      _c(
                        "ul",
                        _vm._l(item.prodcutList, function(good, index) {
                          return _c(
                            "li",
                            {
                              key: index,
                              on: {
                                click: function($event) {
                                  _vm.godetail(good)
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "recommendImg" }, [
                                _c("img", {
                                  attrs: { src: good.image, alt: "" }
                                })
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "recommendDescribe" }, [
                                _vm._v(_vm._s(good.name))
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "goodIntegral" },
                                [
                                  good.maxDeductionAmount
                                    ? _c("integralDeduction", {
                                        attrs: { goodData: good }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "goodDescribe" }, [
                                _c("div", { staticClass: "describeLeft" }, [
                                  _vm._v("￥" + _vm._s(good.minPrice))
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "describeRight" }, [
                                  _vm._v(_vm._s(good.salesNum) + "人已买")
                                ])
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ])
                : _vm._e()
            ])
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.initShow,
                  expression: "initShow"
                }
              ],
              staticClass: "bottomText"
            },
            [
              _c("div", { staticClass: "copyright" }, [
                _vm._v("© 2019-" + _vm._s(new Date().getFullYear()) + " "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://beian.miit.gov.cn/",
                      target: "_blank"
                    }
                  },
                  [_vm._v("浙ICP备17054838号")]
                )
              ]),
              _vm._v(" "),
              _c("span", [_vm._v("易联云商城定制版-易联云提供技术支持")])
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.initShow,
                  expression: "initShow"
                }
              ],
              staticClass: "call",
              on: { click: _vm.callFn }
            },
            [
              _c("div", [
                _c("img", {
                  staticClass: "img",
                  attrs: { src: _vm.phoneImg, alt: "" }
                })
              ]),
              _vm._v(" "),
              _vm._m(0)
            ]
          )
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "van-popup",
            {
              staticClass: "classBottom",
              attrs: { position: "bottom" },
              model: {
                value: _vm.callshow,
                callback: function($$v) {
                  _vm.callshow = $$v
                },
                expression: "callshow"
              }
            },
            [
              _c("callPhone", {
                attrs: { iphoneNumber: _vm.merchantInfo.merchantPhone },
                on: { "on-cancel": _vm.closeCall }
              })
            ],
            1
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "spanText" }, [_vm._v("客服")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }